import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Kontaktdaten } from '../../domain/model/kontaktdaten';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class KontaktdatenService {

    private readonly SERVICE_URL = `${environment.API_URL}/admin/kontaktdaten`;

    private http = inject(HttpClient);

    public saveKontaktdaten(kontaktdaten: Kontaktdaten): Observable<Kontaktdaten> {
        return this.http.put(`${this.SERVICE_URL}/${kontaktdaten.id}`, kontaktdaten) as Observable<Kontaktdaten>;
    }

    public createKontaktdaten(kontaktdaten: Kontaktdaten): Observable<Kontaktdaten> {
        return this.http.post(this.SERVICE_URL, kontaktdaten) as Observable<Kontaktdaten>;
    }

    public saveAllKontaktdaten(kontaktdatenList: Kontaktdaten[]): Observable<Kontaktdaten[]> {
        return this.http.put(this.SERVICE_URL, kontaktdatenList) as Observable<Kontaktdaten[]>;
    }

    public deleteKontaktdaten(kontaktdaten: Kontaktdaten): Observable<any> {
        return this.http.delete(`${this.SERVICE_URL}/${kontaktdaten.id}`) as Observable<any>;
    }

    public listKontaktdaten(): Observable<Kontaktdaten[]> {
        return this.http.get(this.SERVICE_URL) as Observable<Kontaktdaten[]>;
    }

    public getKontaktdaten(kontaktdatenId: number): Observable<Kontaktdaten> {
        return this.http.get(`${this.SERVICE_URL}/${kontaktdatenId}`) as Observable<Kontaktdaten>;
    }
}
